"use strict";

var _slicedToArray = require("/Users/ryanmulligan/Developer/gatsby/dotcom/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_camelcase_1 = __importDefault(require("lodash.camelcase"));

var types_1 = require("./types");

function getFlagsProxy(ldClient, rawFlags) {
  var reactOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : types_1.defaultReactOptions;
  var targetFlags = arguments.length > 3 ? arguments[3] : undefined;
  var filteredFlags = filterFlags(rawFlags, targetFlags);

  var _ref = reactOptions.useCamelCaseFlagKeys ? getCamelizedKeysAndFlagMap(filteredFlags) : [filteredFlags],
      _ref2 = _slicedToArray(_ref, 2),
      flags = _ref2[0],
      _ref2$ = _ref2[1],
      flagKeyMap = _ref2$ === void 0 ? {} : _ref2$;

  return {
    flags: reactOptions.sendEventsOnFlagRead ? toFlagsProxy(ldClient, flags, flagKeyMap) : flags,
    flagKeyMap: flagKeyMap
  };
}

exports.default = getFlagsProxy;

function filterFlags(flags, targetFlags) {
  if (targetFlags === undefined) {
    return flags;
  }

  return Object.keys(targetFlags).reduce(function (acc, key) {
    if (hasFlag(flags, key)) {
      acc[key] = flags[key];
    }

    return acc;
  }, {});
}

function getCamelizedKeysAndFlagMap(rawFlags) {
  var flags = {};
  var flagKeyMap = {};

  for (var rawFlag in rawFlags) {
    // Exclude system keys
    if (rawFlag.indexOf('$') === 0) {
      continue;
    }

    var camelKey = (0, lodash_camelcase_1.default)(rawFlag);
    flags[camelKey] = rawFlags[rawFlag];
    flagKeyMap[camelKey] = rawFlag;
  }

  return [flags, flagKeyMap];
}

function hasFlag(flags, flagKey) {
  return Object.prototype.hasOwnProperty.call(flags, flagKey);
}

function toFlagsProxy(ldClient, flags, flagKeyMap) {
  return new Proxy(flags, {
    // trap for reading a flag value using `LDClient#variation` to trigger an evaluation event
    get: function get(target, prop, receiver) {
      var currentValue = Reflect.get(target, prop, receiver);

      if (typeof prop === 'symbol') {
        return currentValue;
      }

      if (currentValue === undefined) {
        return;
      }

      var originalFlagKey = hasFlag(flagKeyMap, prop) ? flagKeyMap[prop] : prop;
      var nextValue = ldClient.variation(originalFlagKey, currentValue);
      return nextValue;
    },
    // disable all mutation functions to make proxy readonly
    setPrototypeOf: function setPrototypeOf() {
      return false;
    },
    set: function set() {
      return false;
    },
    defineProperty: function defineProperty() {
      return false;
    },
    deleteProperty: function deleteProperty() {
      return false;
    },
    preventExtensions: function preventExtensions() {
      return false;
    }
  });
}